import styles from './Charger.module.scss';
import classnames from "classnames";
import Image from "@/app/[lang]/components/shared/SmartImage";
import type { ChargerProps } from "./interface";

// Assets
import charger01 from "@/app/[lang]/components/DinamicMap/assets/ccs-combo-2.svg";
import charger02 from "@/app/[lang]/components/DinamicMap/assets/type-2.svg";
import charger03 from "@/app/[lang]/components/DinamicMap/assets/chademo.svg";

export const STATUS_LABEL = {
  available: 'Disponibil',
  busy: 'Ocupat',
  unavailable: 'Indisponibil',
  maintenance: 'Mentenanță',
  broken: 'Defect',
  reserved: 'Rezervat',
  '24/7': 'Disponibil',
  default: 'Defect'
};

const Charger = (props: ChargerProps) => {
  const { status, type, count } = props;

  const ChargerIcon = ({ type }: { type: string }) => {
    switch(type) {
      case 'CCS':
        return <Image src={charger01.src} alt="PPC Blue Romania Charger Icon" width={33} height={40} loading="lazy" decoding="async" />;
      case 'Type 2':
        return <Image src={charger02.src} alt="PPC Blue Romania Charger Icon" width={43} height={40} loading="lazy" decoding="async" />;
      case 'CHAdeMO':
        return <Image src={charger03.src} alt="PPC Blue Romania Charger Icon" width={40} height={40} loading="lazy" decoding="async" />;
      default:
          return 'Default';
    }
  }

  if(!count){
    return null;
  }

  return(
    <div className={classnames(styles.charger, styles[status])}>
      {/* To be added in V2 */}
      {/*<p><b>{STATUS_LABEL[status]}</b></p>*/}

      <ChargerIcon type={type} />
      <span className={styles.dot} />

      <p>{type}</p>
    </div>
  )
};

export default Charger;
